// Grade 2026/02 transcrita dos PDFs da UNIFENAS-BH.
// O campo sourcePdf preserva as tabelas e o texto extraídos, inclusive escalas de ambulatório.
// As datas dos blocos vêm do calendário já cadastrado em ../data.js; os PDFs de horário não as informam.
// A rotação A/B/C dos blocos 2–4 foi confirmada pela turma.
import sourcePdf from "./sources/period6.json";
const periodDataset = {
  label: "6º período",
  syndromes: {
  "pediatricas2": {
    "name": "Síndromes Pediátricas II",
    "short": "Pediátricas II"
  },
  "nefrouro": {
    "name": "Síndromes Nefro-Urológicas",
    "short": "Nefro-Uro"
  },
  "oncohemato": {
    "name": "Síndromes Onco-Hematológicas",
    "short": "Onco-Hemato"
  },
  "infecciosas": {
    "name": "Síndromes Infecciosas",
    "short": "Infecciosas"
  }
},
  blocks: [
  {
    "number": 1,
    "start": "2026-07-28",
    "end": "2026-08-21",
    "label": "1º bloco"
  },
  {
    "number": 2,
    "start": "2026-08-24",
    "end": "2026-09-25",
    "label": "2º bloco"
  },
  {
    "number": 3,
    "start": "2026-09-28",
    "end": "2026-10-30",
    "label": "3º bloco"
  },
  {
    "number": 4,
    "start": "2026-11-03",
    "end": "2026-12-04",
    "label": "4º bloco"
  }
],
  defaultRotations: {
  "A": {
    "1": "pediatricas2", "2": "nefrouro", "3": "oncohemato", "4": "infecciosas"
  },
  "B": {
    "1": "pediatricas2", "2": "oncohemato", "3": "infecciosas", "4": "nefrouro"
  },
  "C": {
    "1": "pediatricas2", "2": "infecciosas", "3": "nefrouro", "4": "oncohemato"
  }
},
  baseSchedule: {
  "nefrouro": {
    "1": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "2": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "João Pedro",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "João Pedro",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        }
      },
      "pm1": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Luana",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Dourado",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Luana",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Dourado",
          "location": "patologia",
          "kind": "pl"
        }
      }
    },
    "3": {
      "am1": {
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "Poderá ter",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "alterações",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "Poderá ter",
          "kind": "class"
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      }
    },
    "4": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Gustavo",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "",
          "location": "CEASC",
          "kind": "th"
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "",
          "location": "CEASC",
          "kind": "th"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Gustavo",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      }
    }
  },
  "oncohemato": {
    "5": {
      "am1": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "Sala15",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "CEASC",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "Sala15",
          "kind": "pe"
        }
      },
      "am2": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "alterações",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "alterações",
          "kind": "class"
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Monique",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Kevin",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Bruna R",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luisa D",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Monique",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Kevin",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Bruna R",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luisa D",
          "location": "205",
          "kind": "gt"
        }
      }
    },
    "1": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Nonato",
          "location": "Sala TH",
          "kind": "th"
        },
        "3": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Nonato",
          "location": "Sala TH",
          "kind": "th"
        }
      }
    },
    "2": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Denise",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Lemos",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Nonato",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Nonato",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Denise",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Lemos",
          "location": "patologia",
          "kind": "pl"
        }
      }
    },
    "3": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Monique",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Kevin",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Bruna R",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luisa D",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Monique",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Kevin",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Bruna R",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luisa D",
          "location": "205",
          "kind": "gt"
        }
      }
    },
    "4": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    }
  },
  "infecciosas": {
    "1": {
      "am1": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Aline",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Vaz",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Fernando",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Fernando",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Aline",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Vaz",
          "location": "patologia",
          "kind": "pl"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "3": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Diego",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Pietra",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Aristarco",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Adriana C",
          "location": "211",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Diego",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Pietra",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Aristarco",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Adriana C",
          "location": "211",
          "kind": "gt"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "2": {
      "am1": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        }
      },
      "am2": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Natali N",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Natali N",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "5": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Diego",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Pietra",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Aristarco",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Adriana C",
          "location": "211",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Diego",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Pietra",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Aristarco",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Adriana C",
          "location": "211",
          "kind": "gt"
        }
      }
    },
    "4": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    }
  },
  "pediatricas2": {
    "1": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "2": {
      "am1": {
        "1": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "João Pedro",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "João Pedro",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Nonato",
          "location": "",
          "kind": "pe"
        }
      },
      "pm1": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Clarice",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Racciopi",
          "location": "",
          "kind": "pl"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Clarice",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Racciopi",
          "location": "",
          "kind": "pl"
        }
      }
    },
    "3": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rafael M",
          "location": "102",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Vanessa B",
          "location": "103",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Geovana",
          "location": "104",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda",
          "location": "105",
          "kind": "gt"
        }
      }
    },
    "4": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Gustavo",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "",
          "location": "CEASC",
          "kind": "th"
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "",
          "location": "CEASC",
          "kind": "th"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Gustavo",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      }
    }
  }
},
  baseScheduleByLetter: {
  "pediatricas2": {
    "A": {
      "1": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafael M",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Vanessa B",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Geovana",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda",
            "location": "105",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafael M",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Vanessa B",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Geovana",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "João Pedro",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "João Pedro",
            "location": "Simulação",
            "kind": "th"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Nonato",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Nonato",
            "location": "",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Nonato",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Nonato",
            "location": "",
            "kind": "pe"
          }
        },
        "pm1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Clarice",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Racciopi",
            "location": "",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Clarice",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Racciopi",
            "location": "",
            "kind": "pl"
          }
        }
      },
      "3": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafael M",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Vanessa B",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Geovana",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda",
            "location": "105",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rafael M",
            "location": "102",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Vanessa B",
            "location": "103",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Geovana",
            "location": "104",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda",
            "location": "105",
            "kind": "gt"
          }
        }
      },
      "4": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Gustavo",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "CEASC",
            "kind": "th"
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "CEASC",
            "kind": "th"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Gustavo",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        }
      }
    },
    "B": {
      "5": {
        "am1": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "",
            "location": "Sala15",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "",
            "location": "Sala15",
            "kind": "pe"
          }
        },
        "am2": {
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          },
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Monique",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Kevin",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Bruna R",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luisa D",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Monique",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Kevin",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Bruna R",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luisa D",
            "location": "205",
            "kind": "gt"
          }
        }
      },
      "1": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Nonato",
            "location": "Sala TH",
            "kind": "th"
          },
          "3": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Nonato",
            "location": "Sala TH",
            "kind": "th"
          }
        }
      },
      "2": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Lemos",
            "location": "patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Nonato",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Nonato",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Lemos",
            "location": "patologia",
            "kind": "pl"
          }
        }
      },
      "3": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Monique",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Kevin",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Bruna R",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luisa D",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Monique",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Kevin",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Bruna R",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luisa D",
            "location": "205",
            "kind": "gt"
          }
        }
      },
      "4": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      }
    },
    "C": {
      "1": {
        "am1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Aline",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Vaz",
            "location": "patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Fernando",
            "location": "Simulação",
            "kind": "th"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Fernando",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Aline",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Vaz",
            "location": "patologia",
            "kind": "pl"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Diego",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Pietra",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Aristarco",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana C",
            "location": "211",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Diego",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Pietra",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Aristarco",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana C",
            "location": "211",
            "kind": "gt"
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "2": {
        "am1": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          }
        },
        "am2": {
          "2": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          },
          "3": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          },
          "4": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          },
          "1": {
            "code": "Seminários",
            "title": "Seminários",
            "professor": "",
            "location": "",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Natali N",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Natali N",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "5": {
        "am1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Pietra",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Aristarco",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana C",
            "location": "211",
            "kind": "gt"
          },
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Pietra",
            "location": "208",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Diego",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Pietra",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Aristarco",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Adriana C",
            "location": "211",
            "kind": "gt"
          }
        }
      },
      "4": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      }
    }
  }
},
  fixedClinics: {
  "1": {
    "A": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Santa Amélia",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Bruna França",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Gabrielle Rezende",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 4,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Giovanna Fonseca",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cordeiro",
        "location": "Centrode Saúde Padre Tiago",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Clarice Racciopi",
        "location": "Centrode Saúde Itamarati",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Letícia Linhares",
        "location": "Centro de Saúde Jardim Guanabara",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Lajedo",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Centrode Saúde Boa Vista",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cabral",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde Santos Anjos",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Cristiano Bento",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "2": {
    "A": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Santa Amélia",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Bruna França",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Gabrielle Rezende",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 4,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Giovanna Fonseca",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cordeiro",
        "location": "Centrode Saúde Padre Tiago",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Clarice Racciopi",
        "location": "Centrode Saúde Itamarati",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Letícia Linhares",
        "location": "Centro de Saúde Jardim Guanabara",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Lajedo",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Centrode Saúde Boa Vista",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cabral",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde Santos Anjos",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Cristiano Bento",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "3": {
    "A": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Santa Amélia",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Bruna França",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Gabrielle Rezende",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 4,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Giovanna Fonseca",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cordeiro",
        "location": "Centrode Saúde Padre Tiago",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Clarice Racciopi",
        "location": "Centrode Saúde Itamarati",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Letícia Linhares",
        "location": "Centro de Saúde Jardim Guanabara",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Lajedo",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Centrode Saúde Boa Vista",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cabral",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde Santos Anjos",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Cristiano Bento",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "4": {
    "A": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Santa Amélia",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Bruna França",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Gabrielle Rezende",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 4,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Giovanna Fonseca",
        "location": "Centro de Saúde Jardim Alvorada",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Yara Santos",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cordeiro",
        "location": "Centrode Saúde Padre Tiago",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Clarice Racciopi",
        "location": "Centrode Saúde Itamarati",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Letícia Linhares",
        "location": "Centro de Saúde Jardim Guanabara",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Lajedo",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 4,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Centrode Saúde Boa Vista",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 4,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "Eduardo Cabral",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 4,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde Santos Anjos",
        "regional": "Norte",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 4,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Cristiano Bento",
        "location": "Centrode Saúde São Francisco",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 4,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  }
},
  specialtyClinics: {
  "pediatricas2": {
    "4": [
      {
        "day": 3,
        "period": "am",
        "code": "AE4 · URO",
        "title": "URO",
        "professor": "Gustavo M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE4 · NEF",
        "title": "NEF",
        "professor": "Márcia",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "am",
        "code": "AE4 · HEM1",
        "title": "HEM1",
        "professor": "Mayra C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE4 · HEM2",
        "title": "HEM2",
        "professor": "Mayra C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "am",
        "code": "AE4 · INF2",
        "title": "INF2",
        "professor": "Fernando",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE4 · INF1",
        "title": "INF1",
        "professor": "Fernando",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "1": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · URO",
        "title": "URO",
        "professor": "João Pedro",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE1 · NEF",
        "title": "NEF",
        "professor": "Maria Luiza N (contratação)",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "am",
        "code": "AE1 · HEM2",
        "title": "HEM2",
        "professor": "Rosana",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · HEM1",
        "title": "HEM1",
        "professor": "Mayra",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · INF1",
        "title": "INF1",
        "professor": "Hugo S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE1 · INF2",
        "title": "INF2",
        "professor": "Hugo S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 2,
        "period": "pm",
        "code": "AE2 · URO",
        "title": "URO",
        "professor": "Rafael M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE2 · NEF",
        "title": "NEF",
        "professor": "Márcia",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "am",
        "code": "AE2 · HEM1",
        "title": "HEM1",
        "professor": "Rosana L",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "am",
        "code": "AE2 · HEM2",
        "title": "HEM2",
        "professor": "Emanuelle",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE2 · INF1",
        "title": "INF1",
        "professor": "Adriana C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE2 · INF2",
        "title": "INF2",
        "professor": "Adriana C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE3 · NEF",
        "title": "NEF",
        "professor": "Vanessa Belo",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE3 · URO",
        "title": "URO",
        "professor": "João Pedro",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "am",
        "code": "AE3 · HEM1",
        "title": "HEM1",
        "professor": "Ludmila",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE3 · HEM2",
        "title": "HEM2",
        "professor": "Emanuelle",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "am",
        "code": "AE3 · INF2",
        "title": "INF2",
        "professor": "Isabela L",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE3 · INF1",
        "title": "INF1",
        "professor": "Isabela L",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE5 · NEF",
        "title": "NEF",
        "professor": "Maria Luiza N (contratação)",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE5 · URO",
        "title": "URO",
        "professor": "Maxmillan",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE5 · HEM1",
        "title": "HEM1",
        "professor": "Ludmila",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "am",
        "code": "AE5 · HEM2",
        "title": "HEM2",
        "professor": "Mayra C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE5 · INF1",
        "title": "INF1",
        "professor": "Natali N",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE5 · INF2",
        "title": "INF2",
        "professor": "Natali",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  },
  "nefrouro": {
    "4": [
      {
        "day": 3,
        "period": "am",
        "code": "AE4 · URO",
        "title": "URO",
        "professor": "Gustavo M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE4 · NEF",
        "title": "NEF",
        "professor": "Márcia",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "1": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · URO",
        "title": "URO",
        "professor": "João Pedro",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE1 · NEF",
        "title": "NEF",
        "professor": "Maria Luiza N (contratação)",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 2,
        "period": "pm",
        "code": "AE2 · URO",
        "title": "URO",
        "professor": "Rafael M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE2 · NEF",
        "title": "NEF",
        "professor": "Márcia",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE3 · NEF",
        "title": "NEF",
        "professor": "Vanessa Belo",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE3 · URO",
        "title": "URO",
        "professor": "João Pedro",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE5 · NEF",
        "title": "NEF",
        "professor": "Maria Luiza N (contratação)",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE5 · URO",
        "title": "URO",
        "professor": "Maxmillan",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  },
  "oncohemato": {
    "1": [
      {
        "day": 3,
        "period": "am",
        "code": "AE1 · HEM2",
        "title": "HEM2",
        "professor": "Rosana",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · HEM1",
        "title": "HEM1",
        "professor": "Mayra",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 1,
        "period": "am",
        "code": "AE2 · HEM1",
        "title": "HEM1",
        "professor": "Rosana L",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "am",
        "code": "AE2 · HEM2",
        "title": "HEM2",
        "professor": "Emanuelle",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 1,
        "period": "am",
        "code": "AE3 · HEM1",
        "title": "HEM1",
        "professor": "Ludmila",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE3 · HEM2",
        "title": "HEM2",
        "professor": "Emanuelle",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "am",
        "code": "AE3 · INF2",
        "title": "INF2",
        "professor": "Isabela L",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "4": [
      {
        "day": 1,
        "period": "am",
        "code": "AE4 · HEM1",
        "title": "HEM1",
        "professor": "Mayra C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "am",
        "code": "AE4 · HEM2",
        "title": "HEM2",
        "professor": "Mayra C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "am",
        "code": "AE4 · INF2",
        "title": "INF2",
        "professor": "Fernando",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 2,
        "period": "am",
        "code": "AE5 · HEM1",
        "title": "HEM1",
        "professor": "Ludmila",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "am",
        "code": "AE5 · HEM2",
        "title": "HEM2",
        "professor": "Mayra C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  },
  "infecciosas": {
    "1": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE1 · INF1",
        "title": "INF1",
        "professor": "Hugo S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE1 · INF2",
        "title": "INF2",
        "professor": "Hugo S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE2 · INF1",
        "title": "INF1",
        "professor": "Adriana C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE2 · INF2",
        "title": "INF2",
        "professor": "Adriana C",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE3 · INF1",
        "title": "INF1",
        "professor": "Isabela L",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "4": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE4 · INF1",
        "title": "INF1",
        "professor": "Fernando",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE5 · INF1",
        "title": "INF1",
        "professor": "Natali N",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE5 · INF2",
        "title": "INF2",
        "professor": "Natali",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  }
},
  extraCatalog: [],
  sourcePdf
};
export default periodDataset;
